import React, { useMemo } from 'react'
import { Offcanvas } from 'react-bootstrap'

import { hideEmailSidebar, selectDisplayedEmailSidebar } from '../../../store/emailHub/emailSidebar'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'

import { Button } from '../../../components/Button/Button'

import { EmailBusinessEventSidebar } from './EmailBusinessEventSidebar'
import { EmailSidebarType } from './models'

import './EmailSidebar.scss'

export const EmailSidebar: React.FC = () => {
  const dispatch = useAppDispatch()

  const displayedSidebar = useAppSelector(selectDisplayedEmailSidebar)

  const SidebarBody = useMemo(() => {
    if (!displayedSidebar) {
      return null
    }

    switch (displayedSidebar.type) {
      case EmailSidebarType.BUSINESS_EVENTS:
        return (
          <div className='d-flex flex-column flex-grow-1 email-sidebar-content-container'>
            <EmailBusinessEventSidebar />
          </div>
        )
    }
  }, [displayedSidebar])

  const closeSidebar = () => {
    dispatch(hideEmailSidebar())
  }

  return (
    <Offcanvas show={!!displayedSidebar} placement='end' className='email-sidebar-container' onHide={closeSidebar} scroll backdrop={false}>
      {displayedSidebar ? (
        <div className='h-100 py-3 pe-4 ps-3 d-flex flex-column mb-9'>
          <div className='d-flex p-4 align-items-center justify-content-between email-sidebar-header'>
            <div className='d-flex align-items-center gap-2'>
              <i className={`bi ${displayedSidebar.icon} text-white`} />
              <div className='paragraph-large bold text-white'>{displayedSidebar.title}</div>
            </div>
            <Button variant='link' onClick={closeSidebar}>
              <i className='bi bi-x-lg text-white' />
            </Button>
          </div>
          <div className='d-flex flex-column zocks-gap-2 flex-grow-1 overflow-auto'>{SidebarBody}</div>
        </div>
      ) : null}
    </Offcanvas>
  )
}
